import React, {useState} from "react"
import Typography from "@mui/material/Typography"

import {Grid, Paper} from "@mui/material"
import {AuthWallContent} from "../auth-wall-content";


export const ProfilePageSignIn = () => {


    return <Paper>
        <Grid container direction='row' wrap='nowrap' spacing={0}>

            <Grid item xs={0} sm={0} md={5} lg={6}
                  sx={{
                      backgroundColor: "#0c5ea7",
                      backgroundImage: "url(\"/images/authwall-desktop-left.webp\")",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                  }}>
            </Grid>

            <Grid item xs={12} sm={12} md={7} lg={6} sx={{
                p: {
                    sm: 3,
                    md: 4,
                    xs: 2
                },
                border: "1px solid #e5e5e5",
                textAlign: "center"
            }}>
                <AuthWallContent/>
            </Grid>
        </Grid>
    </Paper>

}
